// submoduleSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../services/AxiosInstance";

// Create an async thunk to fetch submodule data
export const fetchsubmoduleData = createAsyncThunk(
  "submodule/fetchsubmoduleData",
  async () => {
    try {
      const response = await axiosInstance.get("admin/submodule/view");
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
);

const submoduleSlice = createSlice({
  name: "submodule",
  initialState: {
    data: [],
    submoduleCount: 0,
    loading: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchsubmoduleData.pending, (state) => {
        state.loading = "loading";
      })
      .addCase(fetchsubmoduleData.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.data = action.payload;
        state.submoduleCount = action.payload.length;
      })
      .addCase(fetchsubmoduleData.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.error.message;
      });
  },
});

export default submoduleSlice.reducer;
